<template>
  <div>
    <div class="row">
      <div class="form-group col-4 d-flex my-4">
        <input
          id="filtro"
          type="text"
          class="form-control"
          :placeholder="`${this.$t(
            'menu.settings.alertsNewsletters.placeholderSearch',
          )}`"
          v-model="filter"
          @keyup="handleFilter"
        />
        <button class="btn btn-outline-primary" @click="cleanFilter">
          {{ $t('menu.settings.alertsNewsletters.buttonClear') }}
        </button>
      </div>
    </div>
    <div>
      <b-table
        striped
        :items="branchItems.branches"
        :fields="fields"
        :busy="loadingBranches"
        responsive
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </template>

        <template v-slot:cell(rule)="row">
          <p :class="row.item.rule ? 'text-dark' : 'text-danger'">
            {{ row.item.rule ? 'Sim' : 'Não' }}
          </p>
        </template>

        <template v-slot:cell(updatedAt)="row">
          <p>
            {{ row.item.updatedAt ? formatDate(row.item.updatedAt) : '-' }}
          </p>
        </template>

        <template v-slot:cell(options)="row">
          <div v-if="row.item.rule">
            <button
              v-b-modal="`modal-alert-rule-branch-edit-${row.item.branchId}`"
              class="btn btn-outline-primary"
            >
              <font-awesome-icon :icon="['fas', 'pen']" />
              <modal-alert-rule-branch-edit
                :branchData="row.item"
                :page="page"
                :filter="filter"
              />
            </button>
            <button
              class="btn btn-outline-danger"
              @click="handleDelete(row.item.rule, row.item.name)"
            >
              <font-awesome-icon :icon="['fas', 'trash-alt']" />
            </button>
          </div>
          <div v-else>
            <button
              v-b-modal="`modal-alert-rule-branch-${row.item.branchId}`"
              class="btn btn-outline-primary"
            >
              <modal-alert-rule-branch
                :branchData="row.item"
                :ruleId="row.item.key"
                :mainRuleId="mainRuleId"
                :page="page"
                :filter="filter"
              />
              <font-awesome-icon :icon="['fas', 'plus']" />
            </button>
          </div>
        </template>
      </b-table>
      <div class="pagination-area-edit-rule mt-1">
        <paginate
          v-model="page"
          :pageCount="Math.ceil(total / this.limit)"
          :clickHandler="getBranches"
          :prevText="'‹'"
          :nextText="'›'"
          :activeClass="'active'"
          :containerClass="'pagination b-pagination'"
          :pageClass="'page-item'"
        ></paginate>
      </div>
    </div>
  </div>
</template>
<script>
import paginate from 'vuejs-paginate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import swal from 'sweetalert';
import api from '../../../../../../services/api';
import modalAlertRuleBranchEdit from '../../../../../molecules/modal-alert-rule-branch-edit';
import modalAlertRuleBranch from '../../../../../molecules/modal-alert-rule-branch';
import EventBus from '../../../../../../eventBus';

export default {
  props: ['mainRuleId'],

  components: {
    modalAlertRuleBranchEdit,
    modalAlertRuleBranch,
    paginate,
  },

  computed: {
    ...mapFields('alertRules', ['branchItems', 'loadingBranches']),
  },

  data: () => ({
    total: 10,
    page: 1,
    limit: 10,
    loading: false,
    userAuth: null,
    filter: null,
    fields: [],
  }),

  methods: {
    ...mapActions('alertRules', ['getBranchRules']),

    async cleanFilter() {
      this.filter = null;
      await this.getBranches();
    },

    async handleFilter() {
      this.page = 1;
      await this.getBranches();
    },

    async handleDelete(ruleId, name) {
      swal({
        title: this.$t(
          'menu.settings.alertsNewsletters.messages.handleDelete.title',
        ),
        text: this.$t(
          'menu.settings.alertsNewsletters.messages.handleDelete.description',
          {
            brachName: `${name}`,
          },
        ),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(
            `${process.env.API_ROOT}/branch-alert-rules/${this.userAuth.companyId}/${ruleId}`,
            {
              headers: { 'x-access-token': this.userAuth.token },
            },
          );

          await this.getBranches();

          swal({
            title: this.$t(
              'menu.settings.alertsNewsletters.messages.deleteRuleBrachSuccess.title',
            ),
            text: this.$t(
              'menu.settings.alertsNewsletters.messages.deleteRuleBrachSuccess.description',
              {
                brachName: `${name}`,
              },
            ),
            icon: 'success',
          });
        }
      });
    },

    formatDate(myDate) {
      const day = lightFormat(new Date(myDate), 'dd/MM/yyyy');
      const time = lightFormat(new Date(myDate), 'HH:mm');
      return `${day} às ${time}`;
    },

    async getBranches() {
      this.loadingBranches = true;
      await this.getBranchRules({
        companyId: this.userAuth.companyId,
        mainRuleId: this.mainRuleId,
        token: this.userAuth.token,
        params: {
          filter: this.filter,
          page: this.page,
          limit: this.limit,
        },
      });

      EventBus.$emit('getFilter', this.filter);

      this.total = this.branchItems.total;
      this.loadingBranches = false;
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getBranches();

    this.fields = [
      {
        key: 'name',
        label: this.$t('menu.settings.alertsNewsletters.labels.branch'),
      },
      {
        key: 'rule',
        label: this.$t('menu.settings.alertsNewsletters.labels.haveAlert'),
        class: 'center-data',
        sortable: true,
      },
      {
        key: 'updatedAt',
        label: this.$t('menu.settings.alertsNewsletters.labels.ruleUpdateDate'),
        class: 'center-data',
        sortable: true,
      },
      {
        key: 'options',
        label: this.$t('menu.settings.alertsNewsletters.labels.options'),
        class: 'center-data',
      },
    ];
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.pagination-area-edit-rule >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-edit-rule .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}
.pagination-area-edit-rule a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/edit-rule/tab-branch-edit/index.vue